import { gql } from "@apollo/client";

export const GET_MERCHANT_APPS_QUERY = gql`
  query GetMerchantApps {
    getMerchantApps {
      id
      config
      app {
        id
        identifier
        name
        description
        configFormDefinition
        appType
        logoUrl
      }
    }
  }
`;

// Temporarily add config back but we should remove this and find another way to determine "syncability" for Deliveroo
export const GET_MERCHANT_APPS_SIMPLE_QUERY = gql`
  query getMerchantApps {
    getMerchantApps {
      id
      config
      app {
        id
        identifier
      }
    }
  }
`;
